import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { AuthContextType } from '@/contexts/AuthContext'
import { Toaster } from '@/components/ui/sonner'

interface RouterContext {
  auth: AuthContextType
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <Toaster />
      {/* TanStackDevtools intentionally not rendered: its floating button sat
          bottom-right over the app chrome and the team confirmed it is unused.
          Same call the portal made for ReactQueryDevtools (app/providers.tsx).
          To debug routing, render <TanStackDevtools> with the
          TanStackRouterDevtoolsPanel plugin here (import from
          '@tanstack/react-devtools' and '@tanstack/react-router-devtools'). */}
    </>
  ),
})
